
import externalConfiguration from '../external-configuration';
import { IE11_safeIncludes } from './utils';

function loadScript( id, src) {
  if( !loadScript.cache) loadScript.cache = {};
  return new Promise( resolve => {
    if( id in loadScript.cache) resolve();
    else {
      loadScript.cache[id] = true;
      let script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.onload = resolve;
      document.head.appendChild(script);
    }
  });
}

export function geo_html5_country( settings) {
  if( !geo_html5_country.cache) geo_html5_country.cache = {};
  return new Promise( (resolve,reject) => {
    if( geo_html5_country.cache.response) resolve( geo_html5_country.cache.response);
    else {
      if( navigator && navigator.geolocation && navigator.geolocation.getCurrentPosition) {
        return navigator.geolocation.getCurrentPosition( resolve, reject);
      } else {
        alert( 'Error, parece que el navegador no soporta geolocalizacion a traves de html5, o esta deshabilitada');
        reject( 'Error, parece que el navegador no soporta geolocalizacion a traves de html5, o esta deshabilitada');
      }
    }
  }).catch( error => {
    if( window.location.protocol === 'http:') {
      window.location.replace( window.location.href.replace( /^http:/, 'https:'));    // Redireccion por que getCurrentPosition solo funciona en https
    }
    if( !geo_html5_country.cache.error) {
      geo_html5_country.cache.error = error;
      alert( 'No se ha podido detectar la ubicacion a traves de html5, asegurese de estar navegando por https, y de dar permiso al navegador para compartir su ubicacion.');
    }
    throw( 'No se ha podido detectar la ubicacion a traves de html5, asegurese de estar navegando por https, y de dar permiso al navegador para compartir su ubicacion.');
  }).then( response => {
    geo_html5_country.cache.response = response;
    // console.log( response); // DEVELOP
    // console.log( settings); // DEVELOP
    return loadScript( 'maps-google-apis-script', `//maps.googleapis.com/maps/api/js?key=${externalConfiguration.googleMapsApiKey}`).then( () => {
      const geocoder = new window.google.maps.Geocoder();
      const latlng = new window.google.maps.LatLng(response.coords.latitude, response.coords.longitude);
      return new Promise( (resolve,reject) => {
        if( geo_html5_country.cache.html5_google_location) resolve( geo_html5_country.cache.html5_google_location);
        else {
          geocoder.geocode( {'latLng': latlng}, (results, status) => {
            // console.log( 'geocoder.geocode - results', results);  // DEVELOP
            if (status === window.google.maps.GeocoderStatus.OK) {
              let country, aal_1, aal_2, city, street;  // TODO implementar un geobloqueo que use todas estas opciones
              results.forEach( address => {
                address.address_components.forEach( address_component => {
                  if( IE11_safeIncludes( address_component.types, 'country')) {
                    country = address_component.short_name;
                  }
                  if( IE11_safeIncludes( address_component.types, 'administrative_area_level_1')) {
                    aal_1 = address_component.short_name;   // !!!!! NO ES EL CODIGO https://es.wikipedia.org/wiki/ISO_3166-2:ES#cite_note-cooficial-3
                  }
                  if( IE11_safeIncludes( address_component.types, 'administrative_area_level_2')) {
                    aal_2 = address_component.short_name;
                  }
                  if( IE11_safeIncludes( address_component.types, 'locality')) {
                    city = address_component.short_name;
                  }
                  if( IE11_safeIncludes( address_component.types, 'route')) {
                    street = address_component.short_name;
                  }
                });
              });
              resolve({ latitude: response.coords.latitude , longitude: response.coords.longitude , country, aal_1, aal_2, city, street, results});
            } else {
              alert( 'Error verificando la localizacion con google, revise su conectividad, asegurese de no estar utilizando proxies, firewalls u otros intermediarios que puedan estar interfiriendo, y recargue la pagina.');
              reject( 'Error verificando la localizacion con google, revise su conectividad, asegurese de no estar utilizando proxies, firewalls u otros intermediarios que puedan estar interfiriendo, y recargue la pagina.');
            }
          });
        }
      }).then( html5_google_location => {
        geo_html5_country.cache.html5_google_location = html5_google_location;
        const { country, aal_2} = html5_google_location;
        if( settings) {  // DEVELOP - geotest / vdm - adver location specific
          if( country) {
            if( aal_2) {
              if( `${country}-${aal_2}` in settings.playbackRestrictions.countriesBlocked) {
                return true; // true -> isBloqued
              }
            // } else {   // TODO comprobar solo cuando el bloqueo regional este activo
            //   alert( 'No se ha podido resolver la localizacion con suficiente precision (provincia), asegurese de no estar utilizando proxies, firewalls u otros intermediarios que puedan estar interfiriendo, y recargue la pagina.');
            //   return Promise.reject( 'No se ha podido resolver la localizacion con suficiente precision (provincia), asegurese de no estar utilizando proxies, firewalls u otros intermediarios que puedan estar interfiriendo, y recargue la pagina.');
            }
            if( country in settings.playbackRestrictions.countriesBlocked) {
              return true;   // true -> isBloqued
            }
            return false;    // false -> not isBloqued
          } else {
            alert( 'No se ha podido resolver la localizacion con suficiente precision (pais), asegurese de no estar utilizando proxies, firewalls u otros intermediarios que puedan estar interfiriendo, y recargue la pagina.');
            return Promise.reject( 'No se ha podido resolver la localizacion con suficiente precision (pais), asegurese de no estar utilizando proxies, firewalls u otros intermediarios que puedan estar interfiriendo, y recargue la pagina.');
          }
        } else {  // DEVELOP - geotest / vdm - adver location specific
          return html5_google_location;
        }
      });
    });
  });
}

export function geoip2_country( settings) {
  const countriesBlocked = settings.playbackRestrictions.countriesBlocked;
  const onlyCountries = Object.keys(countriesBlocked).reduce( (current, next) => current && next.indexOf('-') <= -1, true);
  if( !onlyCountries) return Promise.reject( 'No se ha podido resolver la localizacion con suficiente precision (region)');   // La localizacion regional de maxmind se considera insuficiente, por lo que si la configuracion incluye geobloqueo por regiones, se considera bloquado directamente
  if( !geoip2_country.cache) geoip2_country.cache = {};
  return loadScript( 'maxmind-script', '//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js').then( () => {
    return new Promise( (resolve,reject) => {
      if( geoip2_country.cache.response) resolve(geoip2_country.cache.response);
      else {
        window.geoip2.city( response => {
          resolve( response);
        }, error => {
          console.error( 'Error connecting to geoip2: ', error);
          reject( error);
        });
      }
    }).then( response => {
      geoip2_country.cache.response = response;
      // console.log( response); // DEVELOP
      const country = response.country.iso_code;
      const subdivision_0 = `${country}-${response.subdivisions[0].iso_code}`;    // Comunidad autonoma
      const subdivision_1 = `${country}-${response.subdivisions[1].iso_code}`;    // Provincia
      if( settings) { // DEVELOP - geotest / vdm - adver location specific
        return country in countriesBlocked || subdivision_0 in countriesBlocked || subdivision_1 in countriesBlocked;
      } else {  // DEVELOP - geotest / vdm - adver location specific
        return { country, subdivision_0, subdivision_1, response};
      }
    });
  });
}

/**
 *  Esta conversion no me gusta, deberia forzarse a que los usuario escribieran lo que quieren exactamente y no corregir automaticamente supuesto errores,
 *  pero como estaba asi y se quiere mantener maxima compatibilidad, se crea esta funcion.
 */
function uniformDomain( srcDomain) {
  let domain = srcDomain.toLowerCase();
  domain = /^(https?:)?(\/\/)?(www\.)?([^/:]+)/.exec( domain);
  if( !domain) {
    domain = '';
  }
  return domain[4];
}

function testDomain( settings) {
  //  Aqui seria ideal usar window.top.document.domain, pero los navegadores consideran que leer datos del window.top es una forma de acceso cross-site
  //  por lo que requiere que el dominio en que se vaya a embeber tenga cors configurado de forma que de acceso a nuestro dominio;
  //  en su defecto se usa document.referrer, lo que implica que no diferenciara entre estar embebido y referenciado, y que en caso de multiples niveles
  //  anidacion solo comprobara el mas bajo, en lugar del mas alto como "deberia"
  let topDomain;
  if( window.top.location !== window.location) {
    topDomain = document.referrer;
  } else {
    topDomain = document.domain;
  }
  let isBlock = true;
  if( topDomain !== '') {
    for( let domain of settings.playbackRestrictions.domainsBlocked) {
      if( uniformDomain( domain) === uniformDomain( topDomain)) {
        isBlock = false;
      }
    }
  }
  // if( isBlock) console.log( 'Bloqueando por dominio', topDomain, settings.playbackRestrictions.domainsBlocked);   // DEVELOP
  return isBlock;
}

function testDate( settings) {
  if( !settings.blockingConditions) settings.blockingConditions = {};
  let isBLocked = false;
  const publishDate = new Date( settings.playbackRestrictions.publishDate);
  const unpublishDate = new Date( settings.playbackRestrictions.unpublishDate);
  const publishTimeStamp = new Date( settings.playbackRestrictions.publishTimeStamp * 1000);
  const unpublishTimeStamp = new Date( settings.playbackRestrictions.unpublishTimeStamp * 1000);
  const now = new Date();
  if( publishDate && publishDate > now) {
    // console.log( 'Bloqueando por publishDate', publishDate, now);   // DEVELOP
    settings.blockingConditions.msUntilPublish = publishDate - now;
    isBLocked = true;
  }else if( unpublishDate && unpublishDate < now && unpublishDate > 0) {
    // console.log( 'Bloqueando por unpublishDate', unpublishDate, now);   // DEVELOP
    isBLocked = true;
  }
  if( publishTimeStamp && publishTimeStamp > now) {
    // console.log( 'Bloqueando por publishTimeStamp', publishTimeStamp, now);   // DEVELOP
    settings.blockingConditions.msUntilPublish = publishTimeStamp - now;
    isBLocked = true;
  }else if( settings.playbackRestrictions.unpublishTimeStamp !== '' && unpublishTimeStamp && unpublishTimeStamp < now) {
    // console.log( 'Bloqueando por unpublishTimeStamp', unpublishTimeStamp, now);   // DEVELOP
    isBLocked = true;
  }
  return isBLocked;
}

function testRestrictions( settings) {
  let promiseOfRestrictions = Promise.resolve( settings);
  if( !settings.legacy) {
    ; // TODO:
      //promiseOfRestrictions = fetch helpers.getRestrictionsSettings( settings.playbackRestrictionsId).then( (restrictionSettings) => {
      //  settings.playbackRestrictions = restrictionSettings;
      //  retun settings;
      //});
  }
  return promiseOfRestrictions.then( (settings) => {
    if( !settings.playbackRestrictions) {
      return new Promise( resolve => resolve(settings));
    }
    return new Promise( resolve => {
      resolve( false);
    }).then( isBLocked => {
      const state = settings.playbackRestrictions.state && settings.playbackRestrictions.state !== '0';
      if( !isBLocked && !state) {  // state = isVideoActive = { '0': false, '1': true} => isBLocked = !isVideoActive
        // console.log( 'Bloqueando por video inactivo', settings.playbackRestrictions.state);    // DEVELOP
        return true;
      }
      return isBLocked;
    }).then( isBLocked => {
      if( !isBLocked && ( !!settings.playbackRestrictions.publishDate || !!settings.playbackRestrictions.unpublishDate
                        || !!settings.playbackRestrictions.publishTimeStamp || !!settings.playbackRestrictions.unpublishTimeStamp)) {
        return testDate( settings);
      }
      return isBLocked;
    }).then( isBLocked => {
      if( !isBLocked && settings.playbackRestrictions.domainBlockActive) {
        return testDomain( settings);
      }
      return isBLocked;
    }).then( isBLocked => {
      if( !isBLocked && settings.playbackRestrictions.countryBlockActive) {
        return geo_html5_country( settings)   // REVIEW deberia intentar html5_google y en caso de fallo entonces provar geoip2_maxmind
        .catch( err => {                      // TODO evaluar si se prefiere que se pueda elegir
          return geoip2_country( settings).catch( err => Promise.resolve(true));  // Si no se puede verificar localizacion, true => bloqueado por defecto
        });
      }
      return isBLocked;
    }).then( isBLocked => {
      if( isBLocked) {
        settings.visualizerType = 'Block';
      }
      return settings;
    });
  });
}

export { testRestrictions };



// WEBPACK FOOTER //
// ./src/helpers/playback-restrictions.js